module.exports = __webpack_public_path__ + "img/helal-ahmar.f4c1163.png";